import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  static targets = ["pricesContainer", "priceTemplate", "dateInput"]
  static values = { nextIndex: Number }

  connect() {
    this.flatpickrInstances = []
    if (!this.hasNextIndexValue) {
      this.nextIndexValue = this.pricesContainerTarget.querySelectorAll("[data-price-row]").length
    }
    this.initDatePickers()
  }

  disconnect() {
    this.flatpickrInstances?.forEach((instance) => instance.destroy())
    this.flatpickrInstances = []
  }

  addPriceRow(event) {
    event.preventDefault()
    const index = this.nextIndexValue
    const html = this.priceTemplateTarget.innerHTML.replace(/NEW_RECORD/g, index)
    this.pricesContainerTarget.insertAdjacentHTML("beforeend", html)
    const newRow = this.pricesContainerTarget.lastElementChild
    this.initDatePickers(newRow)
    this.nextIndexValue = index + 1
  }

  removePriceRow(event) {
    event.preventDefault()
    const row = event.target.closest("[data-price-row]")
    if (!row) return

    const destroyField = row.querySelector("[data-destroy-field]")
    if (destroyField) {
      destroyField.value = "1"
      row.querySelectorAll("input:not([type=hidden]), select, textarea").forEach((input) => {
        input.required = false
        input.disabled = true
      })
      row.classList.add("hidden")
      return
    }

    row.remove()
  }

  initDatePickers(scope = this.element) {
    const dateInputs = scope.querySelectorAll('[data-product-form-target="dateInput"]')
    dateInputs.forEach((input) => {
      if (input.dataset.flatpickrInitialized === "true") return

      const appendTo = input.closest("dialog") || document.body
      this.flatpickrInstances.push(flatpickr(input, {
        dateFormat: "Y-m-d",
        allowInput: true,
        disableMobile: true,
        appendTo
      }))
      input.dataset.flatpickrInitialized = "true"
    })
  }
}
